var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader-container",class:{
    'padding-top': !_vm.isLinear && _vm.withPaddingTop,
    'is-linear': _vm.isLinear,
  }},[(_vm.isLinear)?_c('v-progress-linear',{attrs:{"indeterminate":"","absolute":"","color":_vm.color,"height":_vm.$vuetify.breakpoint.mdAndUp ? 4 : 2}}):_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":"","size":_vm.$vuetify.breakpoint.mdAndUp ? 40 : 30}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }